const SECTION = 'usually_booked_for';

const trackEvent = (eventName, data) => {
  if (App?.track?.event) {
    App.track.event(eventName, { section: SECTION, ...data });
  }
};

const updateArrowsState = (track, prevButton, nextButton) => {
  prevButton.disabled = track.scrollLeft <= 0;
  nextButton.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
};

export const initPreviousEvents = ({ eventName }) => {
  const root = document.querySelector('.js-previous-events');
  if (!root) return;

  const count = Number(root.dataset.cardsCount);

  const sectionObserver = new IntersectionObserver((entries) => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    trackEvent(eventName, { element: 'previous_events', element_value: count, interaction: 'visible' });
    sectionObserver.disconnect();
  }, { threshold: 0.2 });
  sectionObserver.observe(root);

  const track = root.querySelector('.js-previous-events-track');
  const prevButton = root.querySelector('.js-previous-events-prev');
  const nextButton = root.querySelector('.js-previous-events-next');
  if (!track || !prevButton || !nextButton) return;

  const scrollByOneCard = (direction) => {
    const firstCard = track.querySelector('article');
    if (!firstCard) return;

    const cardGap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: direction * (firstCard.offsetWidth + cardGap), behavior: 'smooth' });
    trackEvent(eventName, { element: 'arrows', element_value: count, interaction: 'click' });
  };

  prevButton.addEventListener('click', () => scrollByOneCard(-1));
  nextButton.addEventListener('click', () => scrollByOneCard(1));

  track.addEventListener('scroll', () => updateArrowsState(track, prevButton, nextButton));
  updateArrowsState(track, prevButton, nextButton);
};
